import React, { FC } from 'react';
import s from './accordionItem.module.scss';
interface Props {
  children: React.ReactNode;
}
export const Body: FC<Props> = ({
  children
}) => {
  return <div className={s.accordionItemBody} data-sentry-component="Body" data-sentry-source-file="Body.tsx">
            {children}
        </div>;
};